import { Badge } from "@/components/Badge";
import { HStack, VStack } from "@/components/Layout";
import type { DeviceGenre } from "@/constants/device";
import { defaultNS } from "@/lib/i18n";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LabelDevice } from "../LabelDevice/LabelDevice";

export type DevicePreviewData = {
  /**
   * デバイスID
   */
  deviceId?: string;
  /**
   * ジャンル
   */
  genre: DeviceGenre;
  /**
   * デバイス名
   */
  name: string;
  /**
   * デバイスのタグ（なに表示するか悩み中...）※未実装
   */
  // tags?: string[];
  /**
   * アバターURL
   */
  avatarUrl?: string;
};

type Props = {
  /**
   * 人物情報
   */
  device: DevicePreviewData;
  /**
   * 「プロフィールを見る」リンクの表示可否
   */
  showProfileLink?: boolean;
  /**
   * リンク表示テキスト
   */
  linkText?: string;
  /**
   * クラス名
   */
  className?: string;
};

/**
 * 人物プレビューカードのコンテンツコンポーネント
 */
export function DevicePreviewContent({
  device,
  showProfileLink = true,
  linkText,
  className,
}: Props) {
  const { t } = useTranslation(defaultNS);

  return (
    <VStack className={className}>
      <VStack className="gap-2 max-w-2xl">
        {device.genre && (
          <HStack className="items-center">
            <Badge variant="primaryMuted" className="capitalize">
              {t(`domain.device.genre.${device.genre}`)}
            </Badge>
          </HStack>
        )}
        <HStack className="items-center gap-2">
          <LabelDevice
            genre={device.genre}
            name={device.name}
            avatarUrl={device.avatarUrl}
            size="Default"
            hoverScale={false}
          />
          {/* いくつか識別情報があるはずなのでどれを出すかは要検討。設定かも。 */}
          {/* {device.tag && (
            <Text variant={TextVariant.label}>{device.tag}</Text>
          )} */}
        </HStack>
      </VStack>
      {showProfileLink && device.deviceId && (
        <HStack className="mt-2 justify-end">
          <Link
            to="/profile/device/$id"
            params={{ id: device.deviceId }}
            className="flex items-center justify-center font-semibold text-muted-foreground hover:text-primary"
          >
            {linkText || t("component.PersonPreviewContent.goToProfile")}
          </Link>
        </HStack>
      )}
    </VStack>
  );
}
